// Constants.js
import WorklobJOB from "../abi/WorklobJOB.json";
import LOBToken from "../abi/LOBToken.json";
import WorkLobStaking from "../abi/WorkLobStaking.json";
import WorkLobDAO from "../abi/WorkLobDAO.json";
import IERC20Metadata from "../abi/IERC20Metadata.json";
import { WORKLOOB_NET, toWalletChainParams } from "./workloobNetwork";

export const JOB_ABI = WorklobJOB.abi;
export const JOB_CONTRACT_ADDRESS = WORKLOOB_NET.worklobJobAddress;

export const DEPLOYER_WALLET_ADDRESS = WORKLOOB_NET.deployerWallet;

export const LOB_TOKEN_ABI = LOBToken.abi;
export const LOB_TOKEN_ADDRESS = WORKLOOB_NET.lobTokenAddress;

export const USDC_TOKEN_ABI = [
  ...IERC20Metadata.abi,
  "function nonces(address owner) view returns (uint256)",
  "function version() view returns (string)",
  "function permit(address owner, address spender, uint256 value, uint256 deadline, uint8 v, bytes32 r, bytes32 s)",
];
export const USDC_TOKEN_ADDRESS = WORKLOOB_NET.usdc;
export { USDC_DECIMALS } from "./usdc";

export const WorkLobStaking_abi = WorkLobStaking.abi;
export const WorkLobStaking_address = WORKLOOB_NET.worklobStakingAddress;

export const WorkLobDAO_abi = WorkLobDAO.abi;
export const WorkLobDAO_address = WORKLOOB_NET.worklobDaoAddress;

/** Wallet / Web3 chain params (Sepolia by default, mainnet when REACT_APP_WORKLOOB_NETWORK=mainnet). */
export const BASE_CHAIN_PARAMS = toWalletChainParams(WORKLOOB_NET);

/** @deprecated Use BASE_CHAIN_PARAMS — kept for existing imports */
export const BASE_TESTNET_PARAMS = BASE_CHAIN_PARAMS;

export { WORKLOOB_NET, getWorkloobNetwork, isMainnetMode } from "./workloobNetwork";
